module.exports = function() { return __webpack_public_path__ + "IPM-hero-1.39KOENkBWC-EO145Qq6z.svg";};